import HttpRequest from './http_request'
import { getCurrentBranchPOS } from '@/utils/helper/localStorage'

class PromotionProvider extends HttpRequest {
  constructor () {
    super(`${process.env.NEW_API}/public/5e3548c2d32cb12606a34fb8`)
  }

  async createOrderHistory (payload) {
    const omsBranch = getCurrentBranchPOS()
    const memberOrderHistoryPayload = {
      order: {
        shipping_type: payload.order.bill.cache_shipping_type,
        create_time: payload.order.bill.create_time,
        currency: {
          id: 1,
          name: 'THB'
        },
        current_state: 'paid',
        address: '',
        country: '',
        district: '',
        customer_email: '',
        customer_name: '',
        postcode: '',
        province: '',
        states: '',
        contact_no: payload.tel,
        customer_tel: payload.tel,
        discount: parseFloat(payload.discount),
        expire: payload.order.bill.expire,
        id: payload.order.bill.id,
        net: parseFloat(payload.order.bill.net),
        note: '',
        ship_cost: 0,
        channel_type: 'pos',
        url: payload.order.bill.url
      },
      order_items: payload.items.map(item => {
        const variant1 = item.variant1 ? item.variant1.toLowerCase() : ''
        const variant2 = item.variant2 ? item.variant2.toLowerCase() : ''
        let color = ''
        let size = ''
        if (variant1 === 'color' || variant1 === 'colour') {
          color = item.option1
        } else if (variant2 === 'color' || variant2 === 'colour') {
          color = item.option2
        }

        if (variant1 === 'size') {
          size = item.option1
        } else if (variant2 === 'size') {
          size = item.option2
        }

        return {
          skuId: parseInt(item.id),
          code: item.code,
          name: item.name,
          amount: parseInt(item.amount),
          color: color,
          size: `International:${size}`,
          option: '',
          description: '',
          price: parseFloat(item.priceDiscount),
          full_price: parseFloat(item.price),
          productId: parseInt(item.productId),
          skuImages: [item.image],
          photo_urls: [item.image],
          isOnWeb: true,
          brand: {
            id: 1,
            name: 'gentlewoman'
          },
          warehouse: {
            id: omsBranch.branch_id,
            name: omsBranch.warehouse_display_name,
            code: omsBranch.warehouse
          },
          categories: item.categories,
          tags: item.tags
        }
      }),
      branch: {
        id: omsBranch.branch_id,
        name: omsBranch.warehouse_display_name,
        code: omsBranch.warehouse
      },
      cashier: payload.cashier,
      promotion_code: payload.promotionCode,
      channel: 'pos',
      payment: {
        id: parseInt(payload.order.payment[0].id),
        type: payload.order.payment[0].cache_payment_channel_type,
        name: payload.order.payment[0].cache_payment_channel_name
      }
    }
    try {
      const { data } = await this.create('/members/order-history', memberOrderHistoryPayload)
      return data
    } catch (error) {
      return { success: false }
    }
  }
}

export default PromotionProvider



// WEBPACK FOOTER //
// ./src/resources/member_order_provider.js